'use client';

import { IDigitalCard } from '@/src/types/digitalCards';
import { useInfiniteQuery } from '@tanstack/react-query';
import React, { FC, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { DIGITAL_PAGE_SIZE, DigitalCardsServices } from '../services/DigitalCardsServices';
import Loading from '@/src/components/ui/loading';
import DigitalCard from './DigitalCard';

type Props = {
  initailData: IDigitalCard[];
  query?: string;
  category?: string;
  token?: string;
};

const InfintyDigitalCards: FC<Props> = ({ initailData, query, category, token }) => {
  const [ref, inView] = useInView();

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery({
    queryKey: ['degital-cards', query, category],
    queryFn: async ({ pageParam = 1 }) => {
      const params = {
        Page: pageParam.toString(),
        SearchKey: query,
        CategoryId: category,
      };

      const response = await DigitalCardsServices.getDigitalCards(params);

      return response;
    },
    initialData: {
      pages: [initailData], // Set the first page as initial data
      pageParams: [1],
    },

    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage || lastPage.length < DIGITAL_PAGE_SIZE) return undefined; // stop fetching
      return allPages.length + 1;
    },
    initialPageParam: 1, // Initial page number
    refetchInterval: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, fetchNextPage]);

  return (
    <section>
      <div className="grid grid-cols-[repeat(auto-fill,minmax(170px,1fr))] gap-4 lg:grid-cols-[repeat(auto-fill,minmax(280px,1fr))]">
        {data?.pages.map((page, pIndex) =>
          page.map((card, index) => (
            <DigitalCard key={`${pIndex}-${index}`} data={card} token={token as string} />
          )),
        )}
      </div>

      {/* Observer element */}
      <div ref={ref} style={{ height: '20px' }}>
        {isFetchingNextPage ? <Loading /> : hasNextPage ? <Loading /> : null}
      </div>
    </section>
  );
};

export default InfintyDigitalCards;
